import React from 'react';
import { Row, Content, Message } from 'components/lib';
import { useEffect } from 'react';

export function NoPermission(props) {

	useEffect(() => {
		document.title = props.t('error.403.title')
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return (
		<Row>
			<Content>
				<Message
					type='error'
					title={props.t('error.403.title')}
					text={props.t('error.403.text')}
					buttonText={props.t('error.403.button')}
					buttonLink='/navigate'
				/>
			</Content>
		</Row>
	);
}
